<template>
    <div class="image-box" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="image">
        <img ref="imageContainer" :src="ImagePath" @click="showBigImage()" />
      </div>
    </div>
</template>

<script>
  export default {
    name: 'imagecomponent',
    props: {
      ArticleId: String,
      SerialNo: String,
      ImagePath: String
    },
    data() {
      return {
        fullscreenLoading: false,
      };
    },
    methods: {
      showBigImage (){
        if (this.fullscreenLoading) {
          return
        }
        this.fullscreenLoading = true

        var inputParam = {
          article_id: this.ArticleId,
          serial_no: this.SerialNo
        }
        let routeData = this.$router.resolve({name: 'sp_0001-003', query: inputParam});
        window.open(routeData.href, '_blank');
        this.fullscreenLoading = false;
      },
    }
  };
</script>

<style scoped>
.image-box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  float: left;
  clear: both;
  max-width: 100px;
  margin-right: 10px;
}
.image-box .image img {
  width: 100px;
  height: auto;
  margin-bottom: 5px;
  cursor: pointer;
}
</style>